((Impact, $) => {
  'use strict';

  const addCartAttr = () => {
    if ($.cookie('impact_click_id')) {
      const formData = new FormData();
      formData.append("attributes[impact_click_id]", $.cookie('impact_click_id'));
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
    }
  }

  const observeCart = () => {
    const target = document.querySelector('.inline-cart');
    const callback = (mutationsList, observer) => {
      for(let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          addCartAttr();
          break;
        }
      }
    };
    let observer = new MutationObserver(callback);
    let config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(target, config);
  }

  const bindUIActions = () => {
    const cookieExpiryDays = 30
    // on document load
    $(document).ready(function() {

      const urlParams = new URLSearchParams(window.location.search);
      const clickId = urlParams.get('ClickID') || urlParams.get('irclickid');

      if (clickId && clickId.length) {
        // set ir cookie with click id
        $.cookie('impact_click_id', clickId, {expires: cookieExpiryDays});
      }

      if ($.cookie('impact_click_id') && $.cookie('impact_click_id').length) {
        observeCart();
      }
    });

  };

  Impact.init = () => {
    bindUIActions();
  }

})(window.Impact = window.Impact || {}, jQuery);
